
import { SimpleDialog, Icons } from 'components';
import {
    Typography,
    Button,
} from '@mui/material';
const ErrorDelegationDg = (props) => {
    const { isResultErrorsOpen, handleCloseErrorsModal, rowsWithError, classes } = props;
    return (
        <SimpleDialog
            title="خطا در تفویض وجه"
            icon={<Icons icon='WarningTriangle' color="#F44336" size="22" />}
            open={isResultErrorsOpen}
            actions={
                <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: -8 }}
                    onClick={handleCloseErrorsModal}
                >
                    بستن
                </Button>
            }
        >
            <Typography className={classes.alertTitle}>
                تفویض وجه با خطا مواجه شد. موارد زیر را اصلاح کنید و دوباره تلاش کنید:
            </Typography>
            {rowsWithError?.map((v, k) => (
                <li key={k}>{v}</li>
            ))}
        </SimpleDialog>

    )
}

export default ErrorDelegationDg;